export default __webpack_public_path__ + "static/media/Laptop-And-Mobile-Mock-TPTV.4fb57cfb.png";